import {Classes, Overlay} from '@blueprintjs/core';
import React, {PureComponent} from 'react';
import toastr from 'toastr';

import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InputRegular from '../common/InputRegular';

class EditTagModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                id: '',
                editedTagName: ''
            },
            overlayIsOpen: false,
            errorsList: [],
            fieldsCheckActive: false,
            modalType: 'create'
        };
    }

    doSubmit = async (e) => {
        e.preventDefault();
        this.setState({spinnerActive: true, fieldsCheckActive: true})
        let selectedItem = this.props.selectedItem
        setTimeout(async () => {
            let anyErrorActive = await this.state.data.editedTagName ? false : true;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            if (!anyErrorActive) {
                try {
                    //  console.log(data.tagId)
                    //     console.log('net tag name:', data.new_tag)

                    let tags = await http.patch('api/user/' + selectedItem.user_id + '/source/' + selectedItem.source_id + '/tag/' + selectedItem.id, {tag: this.state.data.editedTagName}, {headers: {authorization: getJwt()}});
                    this.props.handleGetTags();
                    this.props.handleClose();
                    this.setState({
                        spinnerActive: false, done: false, data: {
                            id: '',
                            editedTagName: ''
                        },
                    })
                } catch (ex) {
                    this.setState({spinnerActive: false})
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);

                    }
                }
            } else {
                this.setState({spinnerActive: false})
            }
        }, 500)
    };

    componentDidMount() {

        if (this.props.selectedItem && this.props.selectedItem.tag) {
            this.setState({
                data: {
                    ...this.state.data,
                    editedTagName: this.props.selectedItem.tag
                },
                done: true
            })
        }
    }

    componentDidUpdate() {
        if (!this.state.data.editedTagName && !this.state.done && this.props.selectedItem && this.props.selectedItem.tag) {
            this.setState({
                data: {
                    ...this.state.data,
                    editedTagName: this.props.selectedItem.tag
                },
                done: true
            })
        }
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    render() {
        let {visible_modal, closeModal} = this.props;

        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment"
                     style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>Edit tag</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>
                                <form onSubmit={this.handleFormSubmit}>
                                    <div className="form-group m-m-b">
                                        <InputRegular
                                            id="1"
                                            label1="Edited Tag Name"
                                            label2=""
                                            placeholder=""
                                            type='text'
                                            onChange={e => this.setState({data: {editedTagName: e}})}
                                            value={this.state.data.editedTagName}
                                            updateErrorsList={this.updateErrorsList}
                                            errorMessage="Can't be empty"
                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                            required={true}
                                        />
                                    </div>
                                    <div className='justify-content-end flex-direction-row margin-bottom-30'>
                                        <button disabled={false}
                                                onClick={() => {
                                                    this.props.handleClose();
                                                    this.setState({
                                                        done: false,
                                                        data: {
                                                            id: '',
                                                            editedTagName: ''
                                                        },
                                                    })
                                                }}
                                                name="cancel_edit_tag"
                                                id="cancel_edit_tag"
                                                type="button"
                                                className='btn-white-border margin-right-10'>Cancel
                                        </button>
                                        {!this.state.spinnerActive ?
                                            <button className="btn-action" onClick={this.doSubmit}>Confirm</button>
                                            :
                                            <button className="btn-action btn-spinner" disabled={true}>Confirm <i
                                                className='fa fa-spin fa-spinner'></i></button>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}

export default EditTagModal;